(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pf-article-toc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pf-article-toc')) {
    customElements.define('pf-article-toc', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.build(), {once: true});
        else this.build();
      }
      build() {
        const content = this.closest('.article-template__content');
        if (!content || this.dataset.ready) return;
        const headings = Array.from(content.querySelectorAll('h2, h3'));
        if (headings.length < 2) return;
        const list = this.querySelector('ol');
        headings.forEach((heading, index) => {
          if (!heading.id) {
            let id = 'ruffruff-table-of-contents-item-' + (index + 1);
            while (document.getElementById(id)) id += '-section';
            heading.id = id;
          }
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = '#' + heading.id;
          a.textContent = heading.textContent;
          li.append(a);
          list.append(li);
        });
        this.dataset.ready = 'true';
        this.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pf-cart-discovery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pf-cart-discovery')) {
    customElements.define('pf-cart-discovery', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
        // A single attribute field also supports checkout apps that do not serialize radios.
        this.sourceField = this.querySelector('[data-discovery-empty]');
        this.radios.forEach(radio => { radio.name = 'pf-discovery-choice-' + this.radios[0].id; });
        this.otherField = this.querySelector('.pf-discovery__other');
        this.detailsField = this.querySelector('.pf-discovery__details');
        this.clearButton = this.querySelector('[data-discovery-clear]');
        this.addEventListener('change', () => this.sync());
        this.clearButton.addEventListener('click', () => {
          this.radios.forEach(radio => { radio.checked = false; });
          this.sync();
          this.radios[0].focus();
        });
        this.sync();
      }
      sync() {
        const selected = this.radios.find(radio => radio.checked);
        const isOther = selected && selected.value === 'Other';
        this.sourceField.value = selected ? selected.value : '';
        this.sourceField.disabled = false;
        this.clearButton.hidden = !selected;
        this.otherField.hidden = !isOther;
        if (!isOther) this.detailsField.value = '';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pf-d1-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pf-d1-product')) customElements.define('pf-d1-product', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info');
      if (!this.scope || this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.photoAddon = JSON.parse(this.querySelector('[data-photo-addon]').textContent);
      this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.media = JSON.parse(this.querySelector('[data-size-media]')?.textContent || '{}');
      this.roseHero = JSON.parse(this.querySelector('[data-rose-hero]')?.textContent || 'null');
      this.keepRoseHero = this.roseHero?.initial === true;
      this.money = new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:this.dataset.currency});
      this.sticky = this.querySelector('.pf-d1-sticky');
      if (this.hasAttribute('data-compact')) {
        this.suppressUnverifiedReviews = root => {
          if (root.nodeType === Node.TEXT_NODE) root = root.parentElement;
          if (!root?.querySelectorAll) return;
          const selector = '#vitals-end-section,.Vtl-pr-review-stars-snippet,.vtl-pr-review-stars-snippet';
          if (root.matches?.(selector)) root.remove();
          root.querySelectorAll(selector).forEach(node => node.remove());
          const scripts = root.matches?.('script[type="application/ld+json"]') ? [root] : root.querySelectorAll('script[type="application/ld+json"]');
          scripts.forEach(script => {
            try {
              const data = JSON.parse(script.textContent);
              let changed = false;
              const visit = value => {
                if (Array.isArray(value)) return value.forEach(visit);
                if (!value || typeof value !== 'object') return;
                const types = Array.isArray(value['@type']) ? value['@type'] : [value['@type']];
                if (types.includes('Product')) {
                  if ('aggregateRating' in value) { delete value.aggregateRating; changed = true; }
                  if ('review' in value) { delete value.review; changed = true; }
                }
                Object.values(value).forEach(visit);
              };
              visit(data);
              if (changed) script.textContent = JSON.stringify(data);
            } catch {}
          });
        };
        this.suppressUnverifiedReviews(document);
        this.reviewObserver = new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(this.suppressUnverifiedReviews)));
        this.reviewObserver.observe(document.body,{childList:true,subtree:true});
      }
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; if(this.isConnected) this.sync(); });
      };
      if(this.roseHero){
        this.roseChoice = event => {
          const clickedChoice=event.type==='click'&&event.target.closest('variant-selects button,[data-gift-toggle="greens"]');
          const changedChoice=event.type==='change'&&event.target.closest('variant-selects,[data-element-id="buttons-6"]');
          if(event.isTrusted&&(clickedChoice||changedChoice))this.keepRoseHero=false;
          this.schedule();
        };
        this.scope.addEventListener('click',this.roseChoice,true);
        this.scope.addEventListener('change',this.roseChoice,true);
      }
      this.queueChat = () => {
        if (this.chatFrame) return;
        this.chatFrame = requestAnimationFrame(() => { this.chatFrame = null; if (this.isConnected) this.positionChat(); });
      };
      window.addEventListener('scroll', this.queueChat, {passive: true});
      window.addEventListener('resize', this.queueChat, {passive: true});
      this.controlResize = new ResizeObserver(this.queueChat);
      this.controlResize.observe(this.sticky);
      this.scope.addEventListener('input',this.schedule);
      this.scope.addEventListener('change',this.schedule);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.scope,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','value']});
      this.guard = event => {
        const message=this.scope.querySelector('.gpo-app textarea[id="textarea-1"]');
        if(message && !message.disabled && message.value.length > 200) {
          event.preventDefault(); event.stopImmediatePropagation(); message.setCustomValidity(this.copy.limit); message.reportValidity(); message.focus();
        }
      };
      this.scope.addEventListener('submit',this.guard,true);
      this.revealCustomization = event => {
        if (!this.customization || this.customization.open) return;
        if (event.type === 'invalid' || (event.target.closest?.('.product-form__submit,[data-add]') && this.customization.querySelector('input[original-value="Si"]:checked,input[value="Si"]:checked'))) this.customization.open = true;
      };
      this.scope.addEventListener('click',this.revealCustomization,true);
      this.scope.addEventListener('invalid',this.revealCustomization,true);
      this.querySelector('[data-add]').addEventListener('click',()=>{
        const button=this.scope.querySelector('product-form form .product-form__submit');
        const msg=this.scope.querySelector('.gpo-app textarea[id="textarea-1"]');
        if(msg && !msg.disabled && msg.value.length>200){msg.reportValidity();msg.focus();return;}
        button?.click();
        const invalid=this.scope.querySelector('.gpo-app .messages:not(:empty)');
        if(invalid) invalid.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      });
      if(typeof subscribe==='function') this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,this.schedule);
      this.schedule();
    }
    disconnectedCallback(){window.removeEventListener('scroll',this.queueChat);window.removeEventListener('resize',this.queueChat);this.controlResize?.disconnect();if(this.chatFrame)cancelAnimationFrame(this.chatFrame);if(this.giftBusyTimer)clearTimeout(this.giftBusyTimer);this.chat?.style.removeProperty('--pf-purchase-chat-shift');this.chat?.style.removeProperty('--pf-purchase-chat-x');this.observer?.disconnect();this.reviewObserver?.disconnect();this.unsubscribe?.();this.scope?.removeEventListener('input',this.schedule);this.scope?.removeEventListener('change',this.schedule);this.scope?.removeEventListener('submit',this.guard,true);this.scope?.removeEventListener('click',this.revealCustomization,true);this.scope?.removeEventListener('invalid',this.revealCustomization,true);this.scope?.removeEventListener('click',this.roseChoice,true);this.scope?.removeEventListener('change',this.roseChoice,true);if(this.frame)cancelAnimationFrame(this.frame);this.giftBuilder?.remove();this.caption?.remove();}
    compactCustomization(app) {
      if (!this.hasAttribute('data-compact')) return;
      if (!this.customization?.contains(app)) {
        this.customization?.remove();
        this.customization = document.createElement('details');
        this.customization.className = 'pf-purchase-disclosure pf-purchase-personalization';
        this.customization.open = true;
        const summary = document.createElement('summary');
        const title = document.createElement('h2'); title.className = 'pf-gift-builder__heading'; title.dataset.customizationTitle = '';
        const heading = this.querySelector('[data-gift-heading]');
        if (heading) title.append(heading.content.cloneNode(true)); else title.textContent = this.copy.customization;
        const intro = document.createElement('span'); intro.className = 'pf-gift-builder__intro'; intro.textContent = this.copy.customizationNote;
        const icon = document.createElement('span'); icon.className = 'pf-gift-builder__icon'; icon.textContent = '+'; icon.setAttribute('aria-hidden','true');
        summary.append(title,intro,icon); this.customization.append(summary);
        app.before(this.customization); this.customization.append(app);
        this.customization.addEventListener('toggle',this.schedule);
      }
      const delivery = this.scope.querySelector('.pf-purchase-delivery');
      if (delivery && this.customization.nextElementSibling !== delivery) this.customization.after(delivery);
      if (app.querySelector('.messages:not(:empty)')) this.customization.open = true;
    }
    clickNative(app,id){const input=app.querySelector(`[id="${id}"]`);if(input&&!input.disabled&&!input.checked)input.click();}
    nativePair(app,fieldId,name) {
      const field=app.querySelector(`[data-element-id="${fieldId}"]`);
      return {
        field,
        yes:field?.querySelector(`input[name="${name}"][original-value="Si"],input[name="${name}"][value="Si"]`)||field?.querySelector('input[original-value="Si"],input[value="Si"]'),
        no:field?.querySelector(`input[name="${name}"][original-value="No"],input[name="${name}"][value="No"]`)||field?.querySelector('input[original-value="No"],input[value="No"]')
      };
    }
    setNativeChoice(app,fieldId,name,enabled) {
      const pair=this.nativePair(app,fieldId,name);
      const target=enabled?pair.yes:pair.no;
      if(target&&!target.disabled&&!target.checked)target.click();
      return pair;
    }
    async waitForNativeInput(input,select=false) {
      for(let attempt=0;attempt<24;attempt+=1){
        if(input&&!input.disabled){
          if(select&&!input.checked)input.click();
          return true;
        }
        await new Promise(resolve=>setTimeout(resolve,25));
      }
      return false;
    }
    nativeAddonPrice(input) {
      const dataPrice=Number(input?.dataset.addonPrice||0);
      if(Number.isFinite(dataPrice)&&dataPrice>0)return dataPrice;
      const label=input?.parentElement?.querySelector('.addOn')?.textContent||'';
      const match=label.replace(/\s/g,'').match(/([0-9]+(?:[.,][0-9]+)?)/);
      const labelPrice=Number(match?.[1]?.replace(',','.')||0);
      return Number.isFinite(labelPrice)&&labelPrice>0?labelPrice:0;
    }
    clearNativeFields(root,selector) {
      root.querySelectorAll(selector).forEach(field=>{
        if(field.value==='')return;
        field.value='';
        field.dispatchEvent(new Event('input',{bubbles:true}));
        field.dispatchEvent(new Event('change',{bubbles:true}));
      });
    }
    giftSources(app) {
      return {
        message:this.nativePair(app,'buttons-3','Include message'),
        greens:this.nativePair(app,'buttons-6','Greens'),
        vase:this.nativePair(app,'buttons-1','Incluir Jarrón'),
        roma:app.querySelector('[gpo-data-variant-id="48017998676298"]'),
        sakura:app.querySelector('[gpo-data-variant-id="50991513043274"]'),
        chocolates:this.nativePair(app,'buttons-2','Include chocolates'),
        chocolate:app.querySelector('[gpo-data-variant-id="39387924103191"]'),
        photo:this.nativePair(app,'buttons-5','Polaroid'),
        photoProduct:app.querySelector(`[gpo-data-variant-id="${this.photoAddon.id}"]`),
        plush:this.nativePair(app,'buttons-4','Plush toy animal'),
        plushProducts:[...app.querySelectorAll('[data-element-id="image-swatches-3"] input[gpo-data-variant-id]')]
      };
    }
    mountGiftBuilder(app) {
      if(!this.hasAttribute('data-compact')||this.giftBuilder?.isConnected)return;
      const template=this.querySelector('[data-gift-builder]');
      const anchor=app.querySelector('[data-element-id="buttons-6"]')||app.querySelector('[data-element-id="buttons-3"]');
      if(!template||!anchor)return;
      this.giftBuilder=template.content.firstElementChild.cloneNode(true);
      anchor.before(this.giftBuilder);
      const move=(selector,slot)=>{const target=this.giftBuilder.querySelector(`[data-gift-fields="${slot}"]`);app.querySelectorAll(selector).forEach(node=>target?.append(node));};
      move('[data-element-id="textarea-1"],[data-element-id="text-2"],[data-element-id="text-1"]','message');
      move('[data-element-id="file-1"]','photo');
      move('[data-element-id="image-swatches-3"]','plush');
      for(const key of ['buttons-6','buttons-3','buttons-1','image-swatches-1','buttons-2','image-swatches-2','buttons-4','buttons-5','image-swatches-4'])app.querySelector(`[data-element-id="${key}"]`)?.classList.add('pf-d1-native-option');
      this.giftBuilder.addEventListener('click',async event=>{
        if(this.giftBusy)return;
        const remove=event.target.closest('[data-gift-message-remove]');
        if(remove){
          this.giftBusy=true;
          this.setNativeChoice(app,'buttons-3','Include message',false);
          this.clearNativeFields(app,'textarea[id="textarea-1"],[data-element-id="text-2"] input,[data-element-id="text-1"] input');
          this.giftBusyTimer=setTimeout(()=>{this.giftBusy=false;this.schedule();},220);
          this.schedule();
          return;
        }
        const button=event.target.closest('[data-gift-toggle]');
        if(!button)return;
        this.giftBusy=true;
        const key=button.dataset.giftToggle;
        const source=this.giftSources(app);
        const restorePlushFocus=key==='plush'&&Boolean(source.plush.yes?.checked);
        if(key==='message'){
          if(!source.message.yes?.checked)this.setNativeChoice(app,'buttons-3','Include message',true);
          requestAnimationFrame(()=>app.querySelector('textarea[id="textarea-1"]')?.focus());
        }else if(key==='greens'){
          this.setNativeChoice(app,'buttons-6','Greens',!source.greens.yes?.checked);
        }else if(key==='vase-roma'||key==='vase-sakura'){
          const vase=key==='vase-roma'?source.roma:source.sakura;
          if(source.vase.yes?.checked&&vase?.checked)this.setNativeChoice(app,'buttons-1','Incluir Jarrón',false);
          else{this.setNativeChoice(app,'buttons-1','Incluir Jarrón',true);await this.waitForNativeInput(vase,true);}
        }else if(key==='chocolates'){
          if(source.chocolates.yes?.checked&&source.chocolate?.checked)this.setNativeChoice(app,'buttons-2','Include chocolates',false);
          else{this.setNativeChoice(app,'buttons-2','Include chocolates',true);await this.waitForNativeInput(source.chocolate,true);}
        }else if(key==='photo'){
          if(source.photo.yes?.checked&&source.photoProduct?.checked){this.setNativeChoice(app,'buttons-5','Polaroid',false);this.clearNativeFields(app,'[data-element-id="file-1"] input[type="file"]');}
          else{this.setNativeChoice(app,'buttons-5','Polaroid',true);await this.waitForNativeInput(source.photoProduct,true);}
        }else if(key==='plush'){
          if(source.plush.yes?.checked)this.setNativeChoice(app,'buttons-4','Plush toy animal',false);
          else{this.setNativeChoice(app,'buttons-4','Plush toy animal',true);await this.waitForNativeInput(source.plushProducts[0]);requestAnimationFrame(()=>this.giftBuilder.querySelector('[data-gift-fields="plush"] input:not(:disabled)')?.focus());}
        }
        this.giftBusyTimer=setTimeout(()=>{this.giftBusy=false;this.schedule();if(restorePlushFocus)requestAnimationFrame(()=>{if(button.isConnected&&!button.disabled&&document.activeElement===document.body)button.focus();});},120);
        this.schedule();
      });
    }
    syncGiftBuilder(app) {
      if(!this.giftBuilder?.isConnected)return;
      const source=this.giftSources(app);
      for(const pair of [source.message,source.greens,source.vase,source.chocolates,source.photo,source.plush])if(pair.no&&!pair.no.disabled&&!pair.yes?.checked&&!pair.no.checked)pair.no.click();
      if(source.photo.yes?.checked&&source.photoProduct&&!source.photoProduct.disabled&&!source.photoProduct.checked)source.photoProduct.click();
      const states={
        message:Boolean(source.message.yes?.checked),
        greens:Boolean(source.greens.yes?.checked),
        'vase-roma':Boolean(source.vase.yes?.checked&&source.roma?.checked&&!source.roma.disabled),
        'vase-sakura':Boolean(source.vase.yes?.checked&&source.sakura?.checked&&!source.sakura.disabled),
        chocolates:Boolean(source.chocolates.yes?.checked&&source.chocolate?.checked&&!source.chocolate.disabled),
        photo:Boolean(source.photo.yes?.checked&&source.photoProduct?.checked&&!source.photoProduct.disabled),
        plush:Boolean(source.plush.yes?.checked&&source.plushProducts.some(input=>input.checked&&!input.disabled))
      };
      const available={
        message:Boolean(source.message.yes&&!source.message.yes.disabled&&source.message.no),
        greens:Boolean(source.greens.yes&&!source.greens.yes.disabled&&source.greens.no),
        'vase-roma':Boolean(source.vase.yes&&!source.vase.yes.disabled&&source.vase.no&&source.roma),
        'vase-sakura':Boolean(source.vase.yes&&!source.vase.yes.disabled&&source.vase.no&&source.sakura),
        chocolates:Boolean(source.chocolates.yes&&!source.chocolates.yes.disabled&&source.chocolates.no&&source.chocolate),
        photo:Boolean(source.photo.yes&&!source.photo.yes.disabled&&source.photo.no&&source.photoProduct),
        plush:Boolean(source.plush.yes&&!source.plush.yes.disabled&&source.plush.no&&source.plushProducts.length)
      };
      for(const [key,selected] of Object.entries(states)){
        const row=this.giftBuilder.querySelector(`[data-gift-row="${key}"]`);
        const button=row?.querySelector('[data-gift-toggle]');
        if(!row||!button)continue;
        row.hidden=!available[key];
        row.dataset.selected=String(selected);
        const expanded=key==='message'?selected:key==='photo'?selected:key==='plush'?Boolean(source.plush.yes?.checked):false;
        row.dataset.expanded=String(expanded);
        button.setAttribute('aria-pressed',String(selected));
        if(key==='plush')button.setAttribute('aria-expanded',String(expanded));
        button.disabled=this.giftBusy||!available[key];
        if(key==='message'){
          button.textContent=selected?this.copy.giftEditMessage:this.copy.giftWriteMessage;
          row.querySelector('[data-gift-message-remove]').hidden=!selected;
        }else if(key==='plush'&&expanded&&!selected)button.textContent=button.dataset.giftCancel;
        else button.textContent=selected?this.copy.giftAddedRemove:this.copy.giftAdd;
      }
      const message=app.querySelector('textarea[id="textarea-1"]');
      const preview=this.giftBuilder.querySelector('[data-gift-message-preview]');
      if(preview){
        const value=message?.value.trim()||'';
        const text=states.message&&value?this.copy.giftMessageSaved.replace('[message]',value.length>54?value.slice(0,51)+'…':value):this.copy.giftMessagePrompt;
        if(preview.textContent!==text)preview.textContent=text;
      }
      const syncPrice=(key,input)=>{
        const row=this.giftBuilder.querySelector(`[data-gift-row="${key}"]`);
        if(!row)return;
        const nativePrice=this.nativeAddonPrice(input);
        const cents=Number.isFinite(nativePrice)&&nativePrice>0?Math.round(nativePrice*100):Number(row.dataset.price||0);
        if(!Number.isFinite(cents)||cents<=0)return;
        row.dataset.price=String(cents);
        const priceNode=row.querySelector('[data-gift-price]');
        if(priceNode)priceNode.textContent='+ '+this.money.format(cents/100);
      };
      syncPrice('greens',source.greens.yes);
      syncPrice('vase-roma',source.roma);
      syncPrice('vase-sakura',source.sakura);
      syncPrice('chocolates',source.chocolate);
      syncPrice('photo',source.photoProduct);
      const plushRow=this.giftBuilder.querySelector('[data-gift-row="plush"]');
      const chosen=source.plushProducts.find(input=>input.checked&&!input.disabled);
      const plushPreview=plushRow?.querySelector('[data-plush-preview]');
      const chosenImage=chosen?.nextElementSibling?.querySelector('img');
      if(plushPreview&&chosenImage){
        const src=(chosenImage.currentSrc||chosenImage.src).replace(/([?&])width=\d+/,'$1width=300');
        const displaySrc=src.includes('/swatch-17700552448697.png')?plushPreview.dataset.bearImage:src;
        if(plushPreview.src!==displaySrc)plushPreview.src=displaySrc;
      }
      const prices=source.plushProducts.map(input=>this.nativeAddonPrice(input)).filter(price=>price>0);
      const price=this.nativeAddonPrice(chosen)||Math.min(...prices);
      if(Number.isFinite(price)&&price>0){
        plushRow.dataset.price=String(Math.round(price*100));
        const priceNode=plushRow.querySelector('[data-gift-price]');
        if(priceNode)priceNode.textContent='+ '+this.money.format(price);
      }
    }
    positionChat() {
      const chat = document.querySelector('shopify-chat');
      const activator = chat?.shadowRoot?.querySelector('[part="activator"]');
      if (!activator || !activator.getClientRects().length) return;
      this.chat = chat;
      const rect = activator.getBoundingClientRect();
      const previous = parseFloat(getComputedStyle(chat).getPropertyValue('--pf-purchase-chat-shift')) || 0;
      const slot = this.querySelector('[data-chat-slot]');
      if (slot?.getClientRects().length && this.sticky.getClientRects().length) {
        const target = slot.getBoundingClientRect();
        const previousX = parseFloat(getComputedStyle(chat).getPropertyValue('--pf-purchase-chat-x')) || 0;
        const x = `${Math.round(target.left + (target.width - rect.width) / 2 - (rect.left - previousX))}px`;
        const y = `${Math.round(rect.top + previous - target.top - (target.height - rect.height) / 2)}px`;
        if (chat.style.getPropertyValue('--pf-purchase-chat-x') !== x) chat.style.setProperty('--pf-purchase-chat-x', x);
        if (chat.style.getPropertyValue('--pf-purchase-chat-shift') !== y) chat.style.setProperty('--pf-purchase-chat-shift', y);
        return;
      }
      const previousX = parseFloat(getComputedStyle(chat).getPropertyValue('--pf-purchase-chat-x')) || 0;
      chat.style.removeProperty('--pf-purchase-chat-x');
      const base = {left: rect.left - previousX, right: rect.right - previousX, top: rect.top + previous, bottom: rect.bottom + previous};
      let shift = this.sticky.getClientRects().length ? this.sticky.getBoundingClientRect().height + 12 : 0;
      const button = this.scope.querySelector('product-form .product-form__submit');
      if (button && button !== this.observedButton) { this.controlResize.observe(button); this.observedButton = button; }
      const controls = [button, ...(this.hasAttribute('data-compact') ? this.scope.querySelectorAll('.pf-purchase-disclosure > summary') : [])].filter(Boolean).map(control => control.getBoundingClientRect()).sort((a,b) => b.top - a.top);
      for (const bounds of controls) {
        if (bounds.bottom > 0 && bounds.top < innerHeight && base.right > bounds.left && base.left < bounds.right && base.bottom - shift > bounds.top - 12 && base.top - shift < bounds.bottom + 12) shift = Math.max(shift, base.bottom - bounds.top + 12);
      }
      const value = `${Math.ceil(shift)}px`;
      if (chat.style.getPropertyValue('--pf-purchase-chat-shift') !== value) chat.style.setProperty('--pf-purchase-chat-shift', value);
    }
    sync() {
      const form=this.scope.querySelector('product-form form[data-type="add-to-cart-form"]');
      const app=form?.querySelector('.gpo-app');
      const variant=this.variants.find(v=>String(v.id)===form?.querySelector('[name="id"]')?.value);
      if(!form||!variant)return;
      if(app) {
        const messageChoice=app.querySelector('[data-element-id="buttons-3"]');
        if(messageChoice)this.compactCustomization(app);
        this.mountGiftBuilder(app);
        this.syncGiftBuilder(app);
        const message=app.querySelector('textarea[id="textarea-1"]');
        if(message){
          if(message.maxLength!==200)message.maxLength=200;
          message.setCustomValidity(message.value.length>200?this.copy.limit:'');
          let counter=message.closest('.gpo-element').querySelector('.pf-d1-count');
          if(!counter){counter=document.createElement('span');counter.className='pf-d1-count';counter.id='pf-d1-message-count-'+this.dataset.section;message.closest('.gpo-element').append(counter);message.setAttribute('aria-describedby',[message.getAttribute('aria-describedby'),counter.id].filter(Boolean).join(' '));}
          const count=this.copy.count.replace('[count]',message.value.length);
          if(counter.textContent!==count)counter.textContent=count;
        }
      }
      if(Object.keys(this.media).length){
        const size=parseInt(variant.option1,10);
        const greens=app?this.giftSources(app).greens.yes:null;
        const withGreens=Boolean(greens?.checked&&!greens.disabled);
        const photoKey=this.keepRoseHero&&!withGreens?'hero':`${size}-${withGreens?'eucalyptus':'plain'}`;
        const photo=photoKey==='hero'?this.roseHero:this.media[photoKey];
        const mediaId=photo?.id;
        if(mediaId && this.lastPhotoKey!==photoKey){
          const gallery=this.scope.querySelector('media-gallery');
          if(gallery?.setActiveMedia && gallery.querySelector(`[data-media-id="${this.dataset.section}-${mediaId}"]`)) {gallery.setActiveMedia(`${this.dataset.section}-${mediaId}`,true,false);this.lastPhotoKey=photoKey;}
        }
        const greensPreview=this.giftBuilder?.querySelector('[data-gift-row="greens"] img');
        const greensPhoto=this.media[`${size}-eucalyptus`];
        if(greensPreview&&greensPhoto){
          if(greensPreview.getAttribute('src')!==greensPhoto.url)greensPreview.setAttribute('src',greensPhoto.url);
          if(greensPreview.alt!==greensPhoto.alt)greensPreview.alt=greensPhoto.alt;
        }
        if(!this.caption?.isConnected){this.caption=document.createElement('p');this.caption.className='pf-d1-size-caption';this.caption.setAttribute('aria-live','polite');this.scope.querySelector('media-gallery')?.after(this.caption);}
        const activeId=this.scope.querySelector('media-gallery .product__media-item.is-active')?.dataset.mediaId;
        const showingHero=this.roseHero&&activeId===`${this.dataset.section}-${this.roseHero.id}`;
        const label=showingHero?this.roseHero.caption:mediaId?this.copy.photo.replace('[size]',size):'';
        if(this.caption.textContent!==label)this.caption.textContent=label;
      }
      this.queueChat();
      const button=form.querySelector('.product-form__submit');
      let total=variant.price;
      if(this.giftBuilder?.isConnected)for(const row of this.giftBuilder.querySelectorAll('[data-gift-row][data-selected="true"][data-price]'))total+=Number(row.dataset.price||0);
      const quantity=Number(form.querySelector('[name="quantity"]')?.value||1);
      const formatted=this.money.format(total*quantity/100);
      const totalNode=this.querySelector('[data-total]');if(totalNode.textContent!==formatted)totalNode.textContent=formatted;
      const giftTotal=this.giftBuilder?.querySelector('[data-gift-total]');if(giftTotal&&giftTotal.textContent!==formatted)giftTotal.textContent=formatted;
      const addButton=this.querySelector('[data-add]');
      const disabled=!variant.available||Boolean(button?.disabled)||!app;
      if(addButton.disabled!==disabled)addButton.disabled=disabled;
      if(this.sticky.hidden!==!app)this.sticky.hidden=!app;
      if(button){const label=button.querySelector('span:not(.loading-overlay__spinner)');if(label&&variant.available){const text=this.copy.add+' · '+formatted;if(label.textContent!==text)label.textContent=text;}}
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pf-delivery-video-tracking"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pf-delivery-video-tracking')) {
    customElements.define('pf-delivery-video-tracking', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.sent = new Set();
        this.trace = [];
        this.baseline = 0;
        this.testMode = this.dataset.preview === 'true' && new URLSearchParams(location.search).get('pf_video_debug') === '1';
        this.video = document.querySelector('#pf-ship-video video');
        if (!this.video) {
          this.dataset.state = 'no-video';
          return;
        }
        const options = { signal: this.controller.signal };
        this.video.addEventListener('playing', () => this.start(), options);
        this.video.addEventListener('timeupdate', () => this.progress(), options);
        this.video.addEventListener('ended', () => {
          this.progress();
          if (this.sent.has('video_start')) this.send('video_complete', 100);
        }, options);
        document.addEventListener('visitorConsentCollected', () => {
          this.baseline = this.playedSeconds();
          if (this.ownedTransport) this.transport('consent', 'update', { analytics_storage: this.allowed() ? 'granted' : 'denied' });
          this.updateState();
          if (!this.video.paused && !this.video.ended) this.start();
        }, options);
        this.updateState();
        if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
            if (!this.isConnected) return;
            this.updateState();
            if (!this.video.paused && !this.video.ended) this.start();
          });
        }
      }

      allowed() {
        if (this.testMode) return true;
        try {
          return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
        } catch {
          return false;
        }
      }

      updateState() {
        this.dataset.transport = this.ownedTransport ? this.transportLoaded ? 'dedicated-ready' : 'dedicated-loading' : typeof window.gtag === 'function' ? 'existing' : 'on-demand';
        this.dataset.state = this.testMode ? 'test' : !this.allowed() ? 'consent-required' : this.ownedTransport ? this.transportLoaded ? 'ready' : 'loading-analytics' : typeof window.gtag === 'function' ? 'ready' : 'ready-on-play';
      }

      getTransport() {
        if (this.transport) return this.transport;
        if (typeof window.gtag === 'function') return window.gtag.bind(window);
        const layer = window.pfDeliveryVideoDataLayer = window.pfDeliveryVideoDataLayer || [];
        this.transport = function () { layer.push(arguments); };
        this.ownedTransport = true;
        this.transport('consent', 'default', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
        ['detect_click_events', 'detect_element_visibility_events', 'detect_history_change_events', 'detect_link_click_events', 'detect_timer_events', 'detect_youtube_activity_events', 'detect_scroll_events', 'internal_sw_allowed', 'inject_cmp_banner'].forEach(permission => this.transport('policy', permission, () => false));
        this.transport('set', 'send_page_view', false);
        this.transport('js', new Date());
        this.transport('config', this.dataset.destination, { send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false });
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(this.dataset.destination) + '&l=pfDeliveryVideoDataLayer';
        script.addEventListener('load', () => {
          this.transportLoaded = true;
          this.updateState();
        }, { once: true });
        script.addEventListener('error', () => { this.dataset.state = 'analytics-blocked'; }, { once: true });
        document.head.appendChild(script);
        this.updateState();
        return this.transport;
      }

      playedSeconds() {
        let seconds = 0;
        for (let i = 0; i < this.video.played.length; i++) {
          seconds += this.video.played.end(i) - this.video.played.start(i);
        }
        return seconds;
      }

      watchedPercent() {
        const duration = this.video.duration;
        return Number.isFinite(duration) && duration > 0 ? Math.min(100, Math.max(0, (this.playedSeconds() - this.baseline) / duration * 100)) : 0;
      }

      start() {
        if (this.video.paused || this.video.ended) return;
        if (!this.allowed()) {
          this.baseline = this.playedSeconds();
          this.updateState();
          return;
        }
        this.send('video_start', 0);
      }

      progress() {
        if (this.video.seeking) return;
        if (!this.allowed()) {
          this.baseline = this.playedSeconds();
          this.updateState();
          return;
        }
        if (!this.video.paused) this.start();
        if (this.sent.has('video_start') && this.watchedPercent() >= 50) this.send('video_progress', 50);
      }

      send(name, percent) {
        this.updateState();
        if (this.sent.has(name) || !this.allowed()) return;
        const source = this.video.currentSrc || this.video.querySelector('source')?.src;
        if (!source) return;
        let videoUrl;
        try {
          const url = new URL(source, location.href);
          videoUrl = url.origin + url.pathname;
        } catch {
          return;
        }
        const parameters = {
          send_to: this.dataset.destination,
          event_category: 'video',
          event_label: 'delivery_page_video',
          video_provider: 'Shopify',
          video_title: document.querySelector('#pf-ship-video h2')?.textContent.trim() || 'Persa delivery video',
          video_url: videoUrl,
          video_percent: percent,
          video_current_time: Math.round(this.video.currentTime || 0),
          video_duration: Number.isFinite(this.video.duration) ? Math.round(this.video.duration) : 0,
          watched_percent: Math.round(this.watchedPercent()),
          page_location: location.origin + location.pathname,
          page_path: location.pathname,
          tracking_version: 'delivery_video_v1'
        };
        try {
          if (this.testMode) {
            this.trace.push({ name, parameters });
            this.dataset.events = JSON.stringify(this.trace);
          } else {
            this.getTransport()('event', name, parameters);
          }
          this.sent.add(name);
          this.dataset.lastEvent = name;
        } catch {
          this.dataset.state = 'analytics-error';
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pf-footer-signup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pf-inline-signup')) {
    customElements.define('pf-inline-signup', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.form = this.querySelector('form');
        this.button = this.querySelector('[type="submit"]');
        this.status = this.querySelector('[data-signup-status]');
        this.button.disabled = this.hasAttribute('data-complete');
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          this.subscribe();
        }, { signal: this.controller.signal });
      }
      async subscribe() {
        if (this.pending || this.hasAttribute('data-complete') || !this.form.reportValidity()) return;
        const values = new FormData(this.form);
        const intent = values.get('pf_shopper_type');
        const language = this.dataset.language;
        const list = ({ es: 'QZJ9EA', en: 'XNMz4X' })[language];
        if (!['gifter', 'self'].includes(intent) || !list || list !== this.dataset.list) return;
        this.pending = true;
        this.button.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        this.status.hidden = false;
        this.status.textContent = this.dataset.pending;
        this.request = new AbortController();
        const timer = window.setTimeout(() => this.request.abort(), 15000);
        try {
          const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=TKG7bg', {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-07-15' },
            signal: this.request.signal,
            body: JSON.stringify({ data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Persa D1 footer signup',
                profile: { data: { type: 'profile', attributes: {
                  email: String(values.get('email')).trim(),
                  properties: { pf_shopper_type: intent, pf_language: language, Language: language === 'en' ? 'English' : 'Spanish', pf_signup_source: 'footer' },
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                } } }
              },
              relationships: { list: { data: { type: 'list', id: list } } }
            } })
          });
          if (response.status !== 202) throw new Error('Signup not accepted');
          this.dataset.complete = '';
          this.form.hidden = true;
          this.status.textContent = this.dataset.success;
          this.status.focus({ preventScroll: true });
        } catch {
          if (this.isConnected) this.status.textContent = this.dataset.error;
        } finally {
          window.clearTimeout(timer);
          this.pending = false;
          this.button.disabled = this.hasAttribute('data-complete');
          this.form.removeAttribute('aria-busy');
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.request?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pf-gallery-thumbs"] && !Shopify.designMode) return;
  try {
    (() => {
    const phone = window.matchMedia('(max-width: 749px)');
    const setup = (gallery) => {
      if (gallery.dataset.pfThumbs) return;
      const slider = gallery.querySelector('product-gallery [id^="Slider-"]');
      const strip = gallery.querySelector(':scope > thumbnail-slider .thumbnail-list');
      if (!slider || !strip) return;
      gallery.dataset.pfThumbs = 'true';
      let frame = 0;
      let lockedUntil = 0;
      const activate = (thumb) => {
        if (!thumb) return;
        if (!thumb.classList.contains('is-active')) {
          strip.querySelectorAll('.thumbnail-list__item.is-active').forEach((item) => { item.classList.remove('is-active'); item.querySelector('button')?.removeAttribute('aria-current'); });
          thumb.classList.add('is-active');
          thumb.querySelector('button')?.setAttribute('aria-current', 'true');
        }
        const left = thumb.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2;
        if (Math.abs(strip.scrollLeft - left) > 4) strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      };
      const sync = () => {
        frame = 0;
        if (!phone.matches || performance.now() < lockedUntil) return;
        const slides = Array.from(slider.children).filter((slide) => slide.clientWidth > 0);
        if (!slides.length) return;
        const nearest = slides.reduce((best, slide) => (Math.abs(slide.offsetLeft - slider.scrollLeft) < Math.abs(best.offsetLeft - slider.scrollLeft) ? slide : best));
        activate(strip.querySelector(`[data-target="${nearest.dataset.mediaId}"]`));
      };
      slider.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(sync); }, { passive: true });
      strip.addEventListener('click', (event) => {
        const thumb = event.target.closest('.thumbnail-list__item');
        if (!thumb || !phone.matches) return;
        lockedUntil = performance.now() + 700;
        activate(thumb);
      });
    };
    const run = () => document.querySelectorAll('media-gallery').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pf-gift-message-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pf-gift-message-preview')) {
    customElements.define('pf-gift-message-preview', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('product-info');
        this.source = this.querySelector('template');
        if (!this.scope || !this.source) return;
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            if (this.isConnected) this.sync();
          });
        };
        this.scope.addEventListener('input', this.schedule);
        this.scope.addEventListener('change', this.schedule);
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.scope, {
          childList: true, subtree: true, attributes: true,
          attributeFilter: ['class', 'style', 'hidden', 'disabled']
        });
        this.schedule();
      }

      disconnectedCallback() {
        this.scope?.removeEventListener('input', this.schedule);
        this.scope?.removeEventListener('change', this.schedule);
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.card?.remove();
        this.card = null;
      }

      visible(field) {
        return Boolean(field && !field.disabled && field.getClientRects().length &&
          getComputedStyle(field).visibility !== 'hidden');
      }

      setHidden(node, hidden) {
        if (node.hidden !== hidden) node.hidden = hidden;
      }

      setText(selector, value) {
        const node = this.card.querySelector(selector);
        // Customer text is never interpreted as HTML or stored separately.
        if (node.textContent !== value) node.textContent = value;
        this.setHidden(node, !value.trim());
      }

      sync() {
        const form = this.scope.querySelector('product-form form[data-type="add-to-cart-form"]');
        const app = form?.querySelector('.gpo-app') || this.scope.querySelector('.gpo-app');
        const message = app?.querySelector('textarea[id="textarea-1"]');
        const anchor = form?.querySelector('.product-form__buttons');
        if (!this.visible(message) || !anchor) {
          if (this.card) this.setHidden(this.card, true);
          return;
        }
        if (!this.card?.isConnected) {
          this.card = this.source.content.firstElementChild.cloneNode(true);
          anchor.before(this.card);
        }
        const recipient = app.querySelector('input[id="text-1"]');
        const signature = app.querySelector('input[id="text-2"]');
        this.setText('[data-pf-recipient]', this.visible(recipient) ? recipient.value : '');
        this.setText('[data-pf-message]', message.value);
        this.setText('[data-pf-signature]', this.visible(signature) ? signature.value : '');
        this.setHidden(this.card.querySelector('[data-pf-empty]'), Boolean(message.value.trim()));
        this.setHidden(this.card, false);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pf-guided-base"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pf-guided-base')) customElements.define('pf-guided-base', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info');
      if (!this.scope || this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.photoAddon = JSON.parse(this.querySelector('[data-photo-addon]').textContent);
      this.catalog = JSON.parse(this.querySelector('[data-addon-catalog]')?.textContent || '{}');
      this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.media = JSON.parse(this.querySelector('[data-size-media]')?.textContent || '{}');
      this.roseHero = JSON.parse(this.querySelector('[data-rose-hero]')?.textContent || 'null');
      this.keepRoseHero = this.roseHero?.initial === true;
      this.money = new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:this.dataset.currency});
      this.capabilities = {
        greenery:this.dataset.greeneryEnabled==='true',
        vases:this.dataset.allowVases==='true',
        chocolates:this.dataset.allowChocolates==='true',
        photoIncluded:this.dataset.photoIncluded==='true'
      };
      this.sticky = this.querySelector('.pf-d1-sticky');
      if (this.hasAttribute('data-compact')) {
        this.suppressUnverifiedReviews = root => {
          if (root.nodeType === Node.TEXT_NODE) root = root.parentElement;
          if (!root?.querySelectorAll) return;
          const selector = '#vitals-end-section,.Vtl-pr-review-stars-snippet,.vtl-pr-review-stars-snippet';
          if (root.matches?.(selector)) root.remove();
          root.querySelectorAll(selector).forEach(node => node.remove());
          const scripts = root.matches?.('script[type="application/ld+json"]') ? [root] : root.querySelectorAll('script[type="application/ld+json"]');
          scripts.forEach(script => {
            try {
              const data = JSON.parse(script.textContent);
              let changed = false;
              const visit = value => {
                if (Array.isArray(value)) return value.forEach(visit);
                if (!value || typeof value !== 'object') return;
                const types = Array.isArray(value['@type']) ? value['@type'] : [value['@type']];
                if (types.includes('Product')) {
                  if ('aggregateRating' in value) { delete value.aggregateRating; changed = true; }
                  if ('review' in value) { delete value.review; changed = true; }
                }
                Object.values(value).forEach(visit);
              };
              visit(data);
              if (changed) script.textContent = JSON.stringify(data);
            } catch {}
          });
        };
        this.suppressUnverifiedReviews(document);
        this.reviewObserver = new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(this.suppressUnverifiedReviews)));
        this.reviewObserver.observe(document.body,{childList:true,subtree:true});
      }
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; if(this.isConnected) this.sync(); });
      };
      this.queueChat = () => {
        if (this.chatFrame) return;
        this.chatFrame = requestAnimationFrame(() => { this.chatFrame = null; if (this.isConnected) this.positionChat(); });
      };
      window.addEventListener('scroll', this.queueChat, {passive: true});
      window.addEventListener('resize', this.queueChat, {passive: true});
      this.controlResize = new ResizeObserver(this.queueChat);
      this.controlResize.observe(this.sticky);
      this.scope.addEventListener('input',this.schedule);
      this.scope.addEventListener('change',this.schedule);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.scope,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','value']});
      this.guard = event => {
        const message=this.scope.querySelector('.gpo-app textarea[id="textarea-1"]');
        if(message && !message.disabled && message.value.length > 200) {
          event.preventDefault(); event.stopImmediatePropagation(); message.setCustomValidity(this.copy.limit); message.reportValidity(); message.focus();
        }
      };
      this.scope.addEventListener('submit',this.guard,true);
      if(this.roseHero){
        this.roseChoice = event => {
          const clickedChoice=event.type==='click'&&event.target.closest('variant-selects button,[data-guided-variant],[data-gift-toggle="greens"]');
          const changedChoice=event.type==='change'&&event.target.closest('variant-selects,[data-element-id="buttons-6"]');
          if(event.isTrusted&&clickedChoice)this.keepRoseHero=false;
          this.schedule();
        };
        this.scope.addEventListener('click',this.roseChoice,true);
        this.scope.addEventListener('change',this.roseChoice,true);
      }
      this.onPlushParent = event => {
        if(event.target?.name!=='Plush toy animal')return;
        const yes=this.scope.querySelector('.gpo-app input[name="Plush toy animal"][original-value="Si"],.gpo-app input[name="Plush toy animal"][value="Si"]');
        if(!yes?.checked)this.plushChoosing=false;
      };
      this.scope.addEventListener('change',this.onPlushParent,true);
      this.revealCustomization = event => {
        if (!this.customization || this.customization.open) return;
        if (event.type === 'invalid' || (event.target.closest?.('.product-form__submit,[data-add]') && this.customization.querySelector('input[original-value="Si"]:checked,input[value="Si"]:checked'))) this.customization.open = true;
      };
      this.scope.addEventListener('click',this.revealCustomization,true);
      this.scope.addEventListener('invalid',this.revealCustomization,true);
      this.querySelector('[data-add]').addEventListener('click',()=>{
        const button=this.scope.querySelector('product-form form .product-form__submit');
        const msg=this.scope.querySelector('.gpo-app textarea[id="textarea-1"]');
        if(msg && !msg.disabled && msg.value.length>200){msg.reportValidity();msg.focus();return;}
        button?.click();
        const invalid=this.scope.querySelector('.gpo-app .messages:not(:empty)');
        if(invalid) invalid.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      });
      if(typeof subscribe==='function') this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,this.schedule);
      this.schedule();
    }
    disconnectedCallback(){window.removeEventListener('scroll',this.queueChat);window.removeEventListener('resize',this.queueChat);this.controlResize?.disconnect();if(this.chatFrame)cancelAnimationFrame(this.chatFrame);if(this.giftBusyTimer)clearTimeout(this.giftBusyTimer);this.chat?.style.removeProperty('--pf-purchase-chat-shift');this.chat?.style.removeProperty('--pf-purchase-chat-x');this.observer?.disconnect();this.reviewObserver?.disconnect();this.unsubscribe?.();this.scope?.removeEventListener('input',this.schedule);this.scope?.removeEventListener('change',this.schedule);this.scope?.removeEventListener('submit',this.guard,true);this.scope?.removeEventListener('click',this.roseChoice,true);this.scope?.removeEventListener('change',this.roseChoice,true);this.scope?.removeEventListener('change',this.onPlushParent,true);this.scope?.removeEventListener('click',this.revealCustomization,true);this.scope?.removeEventListener('invalid',this.revealCustomization,true);if(this.frame)cancelAnimationFrame(this.frame);this.giftBuilder?.remove();this.caption?.remove();}
    compactCustomization(app) {
      if (!this.hasAttribute('data-compact')) return;
      if (!this.customization?.contains(app)) {
        this.customization?.remove();
        this.customization = document.createElement('details');
        this.customization.className = 'pf-purchase-disclosure pf-purchase-personalization';
        this.customization.open = true;
        const summary = document.createElement('summary');
        const title = document.createElement('h2'); title.className = 'pf-gift-builder__heading'; title.dataset.customizationTitle = '';
        const heading = this.querySelector('[data-gift-heading]');
        if (heading) title.append(heading.content.cloneNode(true)); else title.textContent = this.copy.customization;
        const intro = document.createElement('span'); intro.className = 'pf-gift-builder__intro'; intro.textContent = this.copy.customizationNote;
        const icon = document.createElement('span'); icon.className = 'pf-gift-builder__icon'; icon.textContent = '+'; icon.setAttribute('aria-hidden','true');
        summary.append(title,intro,icon); this.customization.append(summary);
        app.before(this.customization); this.customization.append(app);
        this.customization.addEventListener('toggle',this.schedule);
      }
      const delivery = this.scope.querySelector('.pf-purchase-delivery');
      if (delivery && this.customization.nextElementSibling !== delivery) this.customization.after(delivery);
      if (app.querySelector('.messages:not(:empty)')) this.customization.open = true;
    }
    setText(node,value){if(node&&node.textContent!==value)node.textContent=value;}
    setAttr(node,name,value){if(node&&node.getAttribute(name)!==value)node.setAttribute(name,value);}
    setFlag(node,name,value){if(node&&node[name]!==value)node[name]=value;}
    optionSetConflict(){
      const ids=['buttons-1','buttons-2','buttons-3','buttons-4','buttons-5','buttons-6','image-swatches-1','image-swatches-2','image-swatches-3','image-swatches-4','textarea-1','text-1','text-2','file-1'];
      return this.scope.querySelectorAll('.gpo-app').length>1||ids.some(id=>this.scope.querySelectorAll(`.gpo-app [data-element-id="${id}"]`).length>1);
    }
    restoreNative(){
      if(this.conflict)return;
      this.conflict=true;
      this.dataset.optionSetConflict='true';
      this.scope.querySelector('pf-guided-layout')?.teardown?.();
      if(this.giftBusyTimer)clearTimeout(this.giftBusyTimer);
      this.giftBusy=false;
      this.plushChoosing=false;
      for(const home of [...(this.homes||[])].reverse())if(home.parent?.isConnected)home.parent.insertBefore(home.node,home.next?.parentNode===home.parent?home.next:null);
      this.homes=[];
      if(this.giftBuilder){
        this.giftBuilder.remove();
        this.giftBuilder=null;
      }
      this.scope.querySelectorAll('.pf-d1-native-option').forEach(node=>node.classList.remove('pf-d1-native-option'));
      if(this.customization)this.customization.open=true;
    }
    catalogEntry(input){const id=input?.getAttribute('gpo-data-variant-id');return id?this.catalog[id]:undefined;}
    sellable(input){return Boolean(input&&this.catalogEntry(input)?.available===true);}
    clickNative(app,id){const input=app.querySelector(`[id="${id}"]`);if(input&&!input.disabled&&!input.checked)input.click();}
    nativePair(app,fieldId,name) {
      const field=app.querySelector(`[data-element-id="${fieldId}"]`);
      return {
        field,
        yes:field?.querySelector(`input[name="${name}"][original-value="Si"],input[name="${name}"][value="Si"]`)||field?.querySelector('input[original-value="Si"],input[value="Si"]'),
        no:field?.querySelector(`input[name="${name}"][original-value="No"],input[name="${name}"][value="No"]`)||field?.querySelector('input[original-value="No"],input[value="No"]')
      };
    }
    setNativeChoice(app,fieldId,name,enabled) {
      if(fieldId==='buttons-4'&&!enabled)this.plushChoosing=false;
      const pair=this.nativePair(app,fieldId,name);
      const target=enabled?pair.yes:pair.no;
      if(target&&!target.disabled&&!target.checked)target.click();
      return pair;
    }
    async waitForNativeInput(input,select=false) {
      for(let attempt=0;attempt<24;attempt+=1){
        if(this.conflict)return false;
        if(input&&!input.disabled){
          if(select&&!input.checked)input.click();
          return true;
        }
        await new Promise(resolve=>setTimeout(resolve,25));
      }
      return false;
    }
    nativeAddonPrice(input) {
      const dataPrice=Number(input?.dataset.addonPrice||0);
      if(Number.isFinite(dataPrice)&&dataPrice>0)return dataPrice;
      const label=input?.parentElement?.querySelector('.addOn')?.textContent||'';
      const match=label.replace(/\s/g,'').match(/([0-9]+(?:[.,][0-9]+)?)/);
      const labelPrice=Number(match?.[1]?.replace(',','.')||0);
      return Number.isFinite(labelPrice)&&labelPrice>0?labelPrice:0;
    }
    clearNativeFields(root,selector) {
      root.querySelectorAll(selector).forEach(field=>{
        if(field.value==='')return;
        field.value='';
        field.dispatchEvent(new Event('input',{bubbles:true}));
        field.dispatchEvent(new Event('change',{bubbles:true}));
      });
    }
    giftSources(app) {
      return {
        message:this.nativePair(app,'buttons-3','Include message'),
        greens:this.nativePair(app,'buttons-6','Greens'),
        vase:this.nativePair(app,'buttons-1','Incluir Jarrón'),
        roma:app.querySelector('[gpo-data-variant-id="48017998676298"]'),
        sakura:app.querySelector('[gpo-data-variant-id="50991513043274"]'),
        chocolates:this.nativePair(app,'buttons-2','Include chocolates'),
        chocolate:app.querySelector('[gpo-data-variant-id="39387924103191"]'),
        photo:this.nativePair(app,'buttons-5','Polaroid'),
        photoProduct:app.querySelector(`[gpo-data-variant-id="${this.photoAddon.id}"]`),
        plush:this.nativePair(app,'buttons-4','Plush toy animal'),
        plushProducts:[...app.querySelectorAll('[data-element-id="image-swatches-3"] input[gpo-data-variant-id]')]
      };
    }
    mountGiftBuilder(app) {
      if(!this.hasAttribute('data-compact')||this.giftBuilder?.isConnected)return;
      const template=this.querySelector('[data-gift-builder]');
      const anchor=app.querySelector('[data-element-id="buttons-6"]')||app.querySelector('[data-element-id="buttons-3"]');
      if(!template||!anchor)return;
      this.giftBuilder=template.content.firstElementChild.cloneNode(true);
      anchor.before(this.giftBuilder);
      this.homes=[];
      const move=(selector,slot)=>{const target=this.giftBuilder.querySelector(`[data-gift-fields="${slot}"]`);if(!target)return;app.querySelectorAll(selector).forEach(node=>{this.homes.push({node,parent:node.parentNode,next:node.nextSibling});target.append(node);});};
      move('[data-element-id="textarea-1"],[data-element-id="text-2"],[data-element-id="text-1"]','message');
      move('[data-element-id="file-1"]',this.capabilities.photoIncluded?'included-photo':'photo');
      move('[data-element-id="image-swatches-3"]','plush');
      for(const key of ['buttons-6','buttons-3','buttons-1','image-swatches-1','buttons-2','image-swatches-2','buttons-4','buttons-5','image-swatches-4'])app.querySelector(`[data-element-id="${key}"]`)?.classList.add('pf-d1-native-option');
      this.giftBuilder.addEventListener('click',async event=>{
        if(this.giftBusy)return;
        const remove=event.target.closest('[data-gift-message-remove]');
        if(remove){
          this.giftBusy=true;
          this.setNativeChoice(app,'buttons-3','Include message',false);
          this.clearNativeFields(app,'textarea[id="textarea-1"],[data-element-id="text-2"] input,[data-element-id="text-1"] input');
          this.giftBusyTimer=setTimeout(()=>{if(this.conflict)return;this.giftBusy=false;this.schedule();},220);
          this.schedule();
          return;
        }
        const button=event.target.closest('[data-gift-toggle]');
        if(!button)return;
        this.giftBusy=true;
        const key=button.dataset.giftToggle;
        const source=this.giftSources(app);
        const restorePlushFocus=key==='plush'&&Boolean(source.plush.yes?.checked);
        if(key==='message'){
          if(!source.message.yes?.checked)this.setNativeChoice(app,'buttons-3','Include message',true);
          requestAnimationFrame(()=>{if(!this.conflict)app.querySelector('textarea[id="textarea-1"]')?.focus();});
        }else if(key==='greens'){
          this.setNativeChoice(app,'buttons-6','Greens',!source.greens.yes?.checked);
        }else if(key==='vase-roma'||key==='vase-sakura'){
          const vase=key==='vase-roma'?source.roma:source.sakura;
          if(source.vase.yes?.checked&&vase?.checked)this.setNativeChoice(app,'buttons-1','Incluir Jarrón',false);
          else{this.setNativeChoice(app,'buttons-1','Incluir Jarrón',true);await this.waitForNativeInput(vase,true);}
        }else if(key==='chocolates'){
          if(source.chocolates.yes?.checked&&source.chocolate?.checked)this.setNativeChoice(app,'buttons-2','Include chocolates',false);
          else{this.setNativeChoice(app,'buttons-2','Include chocolates',true);await this.waitForNativeInput(source.chocolate,true);}
        }else if(key==='photo'){
          if(source.photo.yes?.checked&&source.photoProduct?.checked){this.setNativeChoice(app,'buttons-5','Polaroid',false);this.clearNativeFields(app,'[data-element-id="file-1"] input[type="file"]');}
          else{this.setNativeChoice(app,'buttons-5','Polaroid',true);await this.waitForNativeInput(source.photoProduct,true);}
        }else if(key==='plush'){
          if(source.plush.yes?.checked){this.plushChoosing=false;this.setNativeChoice(app,'buttons-4','Plush toy animal',false);}
          else{
            this.plushChoosing=true;
            this.setNativeChoice(app,'buttons-4','Plush toy animal',true);
            const ready=await this.waitForNativeInput(source.plushProducts.find(input=>this.sellable(input)));
            if(this.conflict)return;
            if(!ready)this.plushChoosing=false;
            else requestAnimationFrame(()=>{if(!this.conflict)this.giftBuilder?.querySelector('[data-gift-fields="plush"] input:not(:disabled)')?.focus();});
          }
        }
        if(this.conflict)return;
        this.giftBusyTimer=setTimeout(()=>{if(this.conflict)return;this.giftBusy=false;this.schedule();if(restorePlushFocus)requestAnimationFrame(()=>{if(!this.conflict&&button.isConnected&&!button.disabled&&document.activeElement===document.body)button.focus();});},120);
        this.schedule();
      });
    }
    syncGiftBuilder(app) {
      if(!this.giftBuilder?.isConnected)return;
      const source=this.giftSources(app);
      if(this.capabilities.photoIncluded){
        if(source.photo.yes?.checked)this.setNativeChoice(app,'buttons-5','Polaroid',false);
        if(source.photoProduct?.checked){source.photoProduct.checked=false;source.photoProduct.dispatchEvent(new Event('change',{bubbles:true}));}
      }
      if(!this.capabilities.greenery&&source.greens.yes?.checked)this.setNativeChoice(app,'buttons-6','Greens',false);
      if(!this.capabilities.vases&&source.vase.yes?.checked)this.setNativeChoice(app,'buttons-1','Incluir Jarrón',false);
      if(!this.capabilities.chocolates&&source.chocolates.yes?.checked)this.setNativeChoice(app,'buttons-2','Include chocolates',false);
      const guarded=[[source.roma,'buttons-1','Incluir Jarrón'],[source.sakura,'buttons-1','Incluir Jarrón'],[source.chocolate,'buttons-2','Include chocolates'],[source.photoProduct,'buttons-5','Polaroid'],...source.plushProducts.map(input=>[input,'buttons-4','Plush toy animal'])];
      for(const [input,fieldId,name] of guarded){
        if(!input||this.sellable(input))continue;
        if(input.checked){input.checked=false;input.dispatchEvent(new Event('change',{bubbles:true}));this.setNativeChoice(app,fieldId,name,false);}
        if(!input.disabled)input.disabled=true;
      }
      for(const pair of [source.message,source.greens,source.vase,source.chocolates,source.photo,source.plush])if(pair.no&&!pair.no.disabled&&!pair.yes?.checked&&!pair.no.checked)pair.no.click();
      if(this.giftBusy&&source.photo.yes?.checked&&this.sellable(source.photoProduct)&&!source.photoProduct.disabled&&!source.photoProduct.checked)source.photoProduct.click();
      if(!source.plush.yes?.checked)this.plushChoosing=false;
      if(!this.giftBusy){
        const chosen=input=>Boolean(input?.checked&&!input.disabled&&this.sellable(input));
        const enforce=[
          [source.greens,'buttons-6','Greens',this.capabilities.greenery&&this.nativeAddonPrice(source.greens.yes)>0],
          [source.vase,'buttons-1','Incluir Jarrón',this.capabilities.vases&&(chosen(source.roma)||chosen(source.sakura))],
          [source.chocolates,'buttons-2','Include chocolates',this.capabilities.chocolates&&chosen(source.chocolate)],
          [source.photo,'buttons-5','Polaroid',!this.capabilities.photoIncluded&&chosen(source.photoProduct)],
          // plush may be "Si" without an animal only while its chooser interaction is open and an animal can be chosen
          [source.plush,'buttons-4','Plush toy animal',source.plushProducts.some(chosen)||Boolean(this.plushChoosing&&source.plushProducts.some(input=>this.sellable(input)))]
        ];
        if(source.plushProducts.some(chosen))this.plushChoosing=false;
        for(const [pair,fieldId,name,valid] of enforce)if(pair.yes?.checked&&!valid)this.setNativeChoice(app,fieldId,name,false);
      }
      const states={
        message:Boolean(source.message.yes?.checked),
        greens:Boolean(source.greens.yes?.checked),
        'vase-roma':Boolean(source.vase.yes?.checked&&source.roma?.checked&&!source.roma.disabled),
        'vase-sakura':Boolean(source.vase.yes?.checked&&source.sakura?.checked&&!source.sakura.disabled),
        chocolates:Boolean(source.chocolates.yes?.checked&&source.chocolate?.checked&&!source.chocolate.disabled),
        photo:Boolean(source.photo.yes?.checked&&source.photoProduct?.checked&&!source.photoProduct.disabled),
        plush:Boolean(source.plush.yes?.checked&&source.plushProducts.some(input=>input.checked&&!input.disabled))
      };
      const available={
        message:Boolean(source.message.yes&&!source.message.yes.disabled&&source.message.no),
        greens:Boolean(this.capabilities.greenery&&source.greens.yes&&!source.greens.yes.disabled&&source.greens.no&&this.nativeAddonPrice(source.greens.yes)>0),
        'vase-roma':Boolean(this.capabilities.vases&&source.vase.yes&&!source.vase.yes.disabled&&source.vase.no&&this.sellable(source.roma)),
        'vase-sakura':Boolean(this.capabilities.vases&&source.vase.yes&&!source.vase.yes.disabled&&source.vase.no&&this.sellable(source.sakura)),
        chocolates:Boolean(this.capabilities.chocolates&&source.chocolates.yes&&!source.chocolates.yes.disabled&&source.chocolates.no&&this.sellable(source.chocolate)),
        photo:Boolean(!this.capabilities.photoIncluded&&source.photo.yes&&!source.photo.yes.disabled&&source.photo.no&&this.sellable(source.photoProduct)),
        plush:Boolean(source.plush.yes&&!source.plush.yes.disabled&&source.plush.no&&source.plushProducts.some(input=>this.sellable(input)))
      };
      for(const [key,selected] of Object.entries(states)){
        const row=this.giftBuilder.querySelector(`[data-gift-row="${key}"]`);
        const button=row?.querySelector('[data-gift-toggle]');
        if(!row||!button)continue;
        this.setFlag(row,'hidden',!available[key]||row.dataset.catalogAvailable==='false');
        this.setAttr(row,'data-selected',String(selected));
        const expanded=key==='message'?selected:key==='photo'?selected:key==='plush'?Boolean(source.plush.yes?.checked):false;
        this.setAttr(row,'data-expanded',String(expanded));
        this.setAttr(button,'aria-pressed',String(selected));
        if(key==='plush')this.setAttr(button,'aria-expanded',String(expanded));
        this.setFlag(button,'disabled',Boolean(this.giftBusy||!available[key]||row.hidden));
        if(key==='message'){
          this.setText(button,selected?this.copy.giftEditMessage:this.copy.giftWriteMessage);
          this.setFlag(row.querySelector('[data-gift-message-remove]'),'hidden',!selected);
        }else if(key==='plush'&&expanded&&!selected)this.setText(button,button.dataset.giftCancel);
        else this.setText(button,selected?this.copy.giftAddedRemove:this.copy.giftAdd);
      }
      const message=app.querySelector('textarea[id="textarea-1"]');
      const preview=this.giftBuilder.querySelector('[data-gift-message-preview]');
      if(preview){
        const value=message?.value.trim()||'';
        const text=states.message&&value?this.copy.giftMessageSaved.replace('[message]',value.length>54?value.slice(0,51)+'…':value):this.copy.giftMessagePrompt;
        if(preview.textContent!==text)preview.textContent=text;
      }
      const syncPrice=(key,input)=>{
        const row=this.giftBuilder.querySelector(`[data-gift-row="${key}"]`);
        if(!row)return;
        const catalogCents=Number(this.catalogEntry(input)?.price||0);
        const nativePrice=this.nativeAddonPrice(input);
        const cents=catalogCents>0?catalogCents:Number.isFinite(nativePrice)&&nativePrice>0?Math.round(nativePrice*100):Number(row.dataset.price||0);
        if(!Number.isFinite(cents)||cents<=0)return;
        this.setAttr(row,'data-price',String(cents));
        this.setText(row.querySelector('[data-gift-price]'),'+ '+this.money.format(cents/100));
      };
      syncPrice('greens',source.greens.yes);
      syncPrice('vase-roma',source.roma);
      syncPrice('vase-sakura',source.sakura);
      syncPrice('chocolates',source.chocolate);
      syncPrice('photo',source.photoProduct);
      const plushRow=this.giftBuilder.querySelector('[data-gift-row="plush"]');
      const chosen=source.plushProducts.find(input=>input.checked&&!input.disabled);
      const plushPreview=plushRow?.querySelector('[data-plush-preview]');
      const chosenImage=chosen?.nextElementSibling?.querySelector('img');
      if(plushPreview&&chosenImage){
        const src=(chosenImage.currentSrc||chosenImage.src).replace(/([?&])width=\d+/,'$1width=300');
        const displaySrc=src.includes('/swatch-17700552448697.png')?plushPreview.dataset.bearImage:src;
        if(plushPreview.src!==displaySrc)plushPreview.src=displaySrc;
      }
      const plushPrice=input=>Number(this.catalogEntry(input)?.price||0)/100||this.nativeAddonPrice(input);
      const prices=source.plushProducts.filter(input=>this.sellable(input)).map(plushPrice).filter(price=>price>0);
      const price=(chosen&&plushPrice(chosen))||Math.min(...prices);
      if(Number.isFinite(price)&&price>0){
        this.setAttr(plushRow,'data-price',String(Math.round(price*100)));
        this.setText(plushRow.querySelector('[data-gift-price]'),'+ '+this.money.format(price));
      }
    }
    positionChat() {
      const chat = document.querySelector('shopify-chat');
      const activator = chat?.shadowRoot?.querySelector('[part="activator"]');
      if (!activator || !activator.getClientRects().length) return;
      this.chat = chat;
      const rect = activator.getBoundingClientRect();
      const previous = parseFloat(getComputedStyle(chat).getPropertyValue('--pf-purchase-chat-shift')) || 0;
      const slot = this.querySelector('[data-chat-slot]');
      if (slot?.getClientRects().length && this.sticky.getClientRects().length) {
        const target = slot.getBoundingClientRect();
        const previousX = parseFloat(getComputedStyle(chat).getPropertyValue('--pf-purchase-chat-x')) || 0;
        const x = `${Math.round(target.left + (target.width - rect.width) / 2 - (rect.left - previousX))}px`;
        const y = `${Math.round(rect.top + previous - target.top - (target.height - rect.height) / 2)}px`;
        if (chat.style.getPropertyValue('--pf-purchase-chat-x') !== x) chat.style.setProperty('--pf-purchase-chat-x', x);
        if (chat.style.getPropertyValue('--pf-purchase-chat-shift') !== y) chat.style.setProperty('--pf-purchase-chat-shift', y);
        return;
      }
      const previousX = parseFloat(getComputedStyle(chat).getPropertyValue('--pf-purchase-chat-x')) || 0;
      chat.style.removeProperty('--pf-purchase-chat-x');
      const base = {left: rect.left - previousX, right: rect.right - previousX, top: rect.top + previous, bottom: rect.bottom + previous};
      let shift = this.sticky.getClientRects().length ? this.sticky.getBoundingClientRect().height + 12 : 0;
      const button = this.scope.querySelector('product-form .product-form__submit');
      if (button && button !== this.observedButton) { this.controlResize.observe(button); this.observedButton = button; }
      const controls = [button, ...(this.hasAttribute('data-compact') ? this.scope.querySelectorAll('.pf-purchase-disclosure > summary') : [])].filter(Boolean).map(control => control.getBoundingClientRect()).sort((a,b) => b.top - a.top);
      for (const bounds of controls) {
        if (bounds.bottom > 0 && bounds.top < innerHeight && base.right > bounds.left && base.left < bounds.right && base.bottom - shift > bounds.top - 12 && base.top - shift < bounds.bottom + 12) shift = Math.max(shift, base.bottom - bounds.top + 12);
      }
      const value = `${Math.ceil(shift)}px`;
      if (chat.style.getPropertyValue('--pf-purchase-chat-shift') !== value) chat.style.setProperty('--pf-purchase-chat-shift', value);
    }
    sync() {
      const form=this.scope.querySelector('product-form form[data-type="add-to-cart-form"]');
      const app=form?.querySelector('.gpo-app');
      const variant=this.variants.find(v=>String(v.id)===form?.querySelector('[name="id"]')?.value);
      if(!form||!variant)return;
      if(this.conflict)return;
      if(this.optionSetConflict()){this.restoreNative();return;}
      if(app) {
        const messageChoice=app.querySelector('[data-element-id="buttons-3"]');
        if(messageChoice)this.compactCustomization(app);
        this.mountGiftBuilder(app);
        this.syncGiftBuilder(app);
        const message=app.querySelector('textarea[id="textarea-1"]');
        if(message){
          if(message.maxLength!==200)message.maxLength=200;
          message.setCustomValidity(message.value.length>200?this.copy.limit:'');
          let counter=message.closest('.gpo-element').querySelector('.pf-d1-count');
          if(!counter){counter=document.createElement('span');counter.className='pf-d1-count';counter.id='pf-d1-message-count-'+this.dataset.section;message.closest('.gpo-element').append(counter);message.setAttribute('aria-describedby',[message.getAttribute('aria-describedby'),counter.id].filter(Boolean).join(' '));}
          const count=this.copy.count.replace('[count]',message.value.length);
          if(counter.textContent!==count)counter.textContent=count;
        }
      }
      if(Object.keys(this.media).length){
        const size=parseInt(variant.option1,10);
        const greens=app?this.giftSources(app).greens.yes:null;
        const withGreens=Boolean(greens?.checked&&!greens.disabled);
        const photoKey=this.keepRoseHero&&!withGreens?'hero':`${size}-${withGreens?'eucalyptus':'plain'}`;
        const photo=photoKey==='hero'?this.roseHero:this.media[photoKey];
        const mediaId=photo?.id;
        if(mediaId && this.lastPhotoKey!==photoKey){
          const gallery=this.scope.querySelector('media-gallery');
          if(gallery?.setActiveMedia && gallery.querySelector(`[data-media-id="${this.dataset.section}-${mediaId}"]`)) {gallery.setActiveMedia(`${this.dataset.section}-${mediaId}`,true,false);this.lastPhotoKey=photoKey;}
        }
        const greensPreview=this.giftBuilder?.querySelector('[data-gift-row="greens"] img');
        const greensPhoto=this.media[`${size}-eucalyptus`];
        if(greensPreview&&greensPhoto){
          if(greensPreview.getAttribute('src')!==greensPhoto.url)greensPreview.setAttribute('src',greensPhoto.url);
          if(greensPreview.alt!==greensPhoto.alt)greensPreview.alt=greensPhoto.alt;
        }
        if(!this.caption?.isConnected){this.caption=document.createElement('p');this.caption.className='pf-d1-size-caption';this.caption.setAttribute('aria-live','polite');this.scope.querySelector('media-gallery')?.after(this.caption);}
        const activeId=this.scope.querySelector('media-gallery .product__media-item.is-active')?.dataset.mediaId;
        const showingHero=this.roseHero&&activeId===`${this.dataset.section}-${this.roseHero.id}`;
        const label=showingHero?this.roseHero.caption:mediaId?this.copy.photo.replace('[size]',size):'';
        if(this.caption.textContent!==label)this.caption.textContent=label;
        if(this.scope.hasAttribute('data-rose-hero-active')!==Boolean(showingHero))this.scope.toggleAttribute('data-rose-hero-active',Boolean(showingHero));
      }
      this.queueChat();
      const button=form.querySelector('.product-form__submit');
      let total=variant.price;
      if(this.giftBuilder?.isConnected)for(const row of this.giftBuilder.querySelectorAll('[data-gift-row][data-selected="true"][data-price]'))total+=Number(row.dataset.price||0);
      const quantity=Number(form.querySelector('[name="quantity"]')?.value||1);
      const formatted=this.money.format(total*quantity/100);
      const totalNode=this.querySelector('[data-total]');if(totalNode.textContent!==formatted)totalNode.textContent=formatted;
      const giftTotal=this.giftBuilder?.querySelector('[data-gift-total]');if(giftTotal&&giftTotal.textContent!==formatted)giftTotal.textContent=formatted;
      const addButton=this.querySelector('[data-add]');
      const disabled=!variant.available||Boolean(button?.disabled)||!app;
      if(addButton.disabled!==disabled)addButton.disabled=disabled;
      if(this.sticky.hidden!==!app)this.sticky.hidden=!app;
      if(button){const label=button.querySelector('span:not(.loading-overlay__spinner)');if(label&&variant.available){const text=this.copy.add;if(label.textContent!==text)label.textContent=text;}}
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pf-guided-layout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pf-guided-layout')) customElements.define('pf-guided-layout', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.scope = this.closest('product-info');
      this.copy = JSON.parse(this.querySelector('[data-guided-copy]').textContent);
      this.groups = {vases:['vase-roma','vase-sakura'],extras:['greens','chocolates','plush','photo']};
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; if (this.isConnected) this.sync(); }); };
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.scope,{subtree:true,childList:true,attributes:true,attributeFilter:['data-selected','disabled','data-expanded','data-has-file']});
      this.scope.addEventListener('input',this.schedule);
      this.scope.addEventListener('change',this.schedule);
      this.schedule();
    }
    disconnectedCallback() {
      if(this.onInvalid)this.scope?.removeEventListener('invalid',this.onInvalid,true);
      this.observer?.disconnect();
      this.scope?.removeEventListener('input',this.schedule);
      this.scope?.removeEventListener('change',this.schedule);
      if(this.frame)cancelAnimationFrame(this.frame);
      this.sizes?.remove();
      this.price?.remove();
      this.dialog?.remove();
    }
    text(node,value) { if(node && node.textContent!==value)node.textContent=value; }
    row(key) { return this.builder?.querySelector(`[data-gift-row="${key}"]`); }
    teardown() {
      this.dead=true;
      this.observer?.disconnect();
      this.scope.removeEventListener('input',this.schedule);
      this.scope.removeEventListener('change',this.schedule);
      if(this.onInvalid)this.scope.removeEventListener('invalid',this.onInvalid,true);
      if(this.frame){cancelAnimationFrame(this.frame);this.frame=null;}
      if(this.dialog?.open)this.dialog.close();
      if(this.dialog&&this.builder){
        const fields=this.dialog.querySelector('[data-guided-panel="message"] > [data-gift-fields="message"]');
        if(fields)this.row('message')?.append(fields);
        const paid=this.builder.querySelector('.pf-gift-builder__paid');
        this.dialog.querySelectorAll('[data-guided-panel] > [data-gift-row]').forEach(row=>paid?.append(row));
      }
      this.sizes?.remove();this.price?.remove();this.controls?.remove();this.dialog?.remove();
      this.scope.classList.remove('pf-guided-ready');
    }
    mount() {
      this.base=this.scope.querySelector('pf-guided-base');
      if(this.base?.conflict||this.base?.optionSetConflict?.())return false;
      this.builder=this.base?.giftBuilder;
      if(!this.builder?.isConnected||!this.base.scope)return false;
      this.app=this.builder.closest('.gpo-app');
      this.form=this.app.closest('form');
      this.controls=this.querySelector('[data-guided-controls]').content.firstElementChild.cloneNode(true);
      this.dialog=this.querySelector('[data-guided-dialog]').content.firstElementChild.cloneNode(true);
      this.builder.querySelector('.pf-gift-builder__paid').before(this.controls);
      this.builder.append(this.dialog);
      for(const [group,keys] of Object.entries(this.groups))for(const key of keys){const row=this.row(key);if(row)this.dialog.querySelector(`[data-guided-panel="${group}"]`).append(row);}
      this.dialog.querySelector('[data-guided-panel="message"]').append(this.builder.querySelector('[data-gift-fields="message"]'));
      this.text(this.row('message').querySelector('.pf-gift-option__copy strong'),this.copy.dedication);
      this.base.copy.giftMessagePrompt=this.copy.message_hint;
      this.base.copy.giftMessageSaved='[message]';
      this.base.copy.add=this.copy.add;
      this.text(this.builder.querySelector('.pf-gift-builder__total > span'),this.copy.gift_total);
      this.sizes=this.querySelector('[data-guided-sizes]').content.firstElementChild.cloneNode(true);
      const nativeSizes=this.scope.querySelector('variant-selects');
      if(nativeSizes)nativeSizes.before(this.sizes);
      this.price=document.createElement('span');this.price.className='pf-guided-base-price';
      this.scope.querySelector('.pf-product-intro').append(this.price);
      this.sizes.addEventListener('click',event=>{const button=event.target.closest('[data-guided-variant]');if(!button)return;this.selectVariant(this.base.variants.find(v=>String(v.id)===button.dataset.guidedVariant));});
      this.sizes.addEventListener('change',event=>{if(event.target.matches('[data-guided-variant-select]'))this.selectVariant(this.base.variants.find(v=>String(v.id)===event.target.value));});
      this.controls.addEventListener('click',event=>{const button=event.target.closest('[data-guided-open]');if(button)this.open(button.dataset.guidedOpen,button);});
      this.builder.addEventListener('click',event=>{const button=event.target.closest('[data-gift-toggle="message"]');if(button){event.preventDefault();event.stopImmediatePropagation();this.open('message',button);}},true);
      this.builder.addEventListener('click',event=>{const row=event.target.closest('.pf-gift-option--free');if(row&&!event.target.closest('button,a,input,textarea,label,select')){event.preventDefault();this.open('message',row.querySelector('[data-gift-toggle="message"]')||row);}},true);
      this.dialog.addEventListener('click',event=>{
        if(event.target.closest('[data-guided-close]'))this.close();
        else if(event.target.closest('[data-guided-save]'))this.save();
        else if(event.target.closest('[data-guided-clear]'))this.clear();
        else if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.close();}
      });
      this.dialog.addEventListener('cancel',event=>{event.preventDefault();this.close();});
      this.onInvalid=event=>{const field=event.target.closest('[data-gift-fields]');if(field&&field.dataset.giftFields!=='included-photo')this.open(field.dataset.giftFields==='message'?'message':'extras');};
      this.scope.addEventListener('invalid',this.onInvalid,true);
      this.scope.classList.add('pf-guided-ready');
      this.mounted=true;
      return true;
    }
    selectVariant(variant) {
      const native=this.scope.querySelector('variant-selects');
      if(!variant||!native)return;
      const groups=[...native.querySelectorAll('fieldset,.product-form__input--dropdown')];
      (variant.options||[variant.option1,variant.option2,variant.option3].filter(Boolean)).forEach((value,index)=>{
        const group=groups[index]||native;
        const radio=[...group.querySelectorAll('input[type="radio"]')].find(input=>input.value===value);
        if(radio&&!radio.checked){radio.click();return;}
        const select=group.querySelector('select');
        if(select&&select.value!==value){select.value=value;select.dispatchEvent(new Event('change',{bubbles:true}));}
      });
    }
    open(group,trigger) {
      this.group=group;this.trigger=trigger||this.controls.querySelector('[data-guided-open="extras"]');
      const titles={message:this.copy.dedication,vases:this.copy.select_vase,extras:this.copy.extras,delivery:this.copy.delivery};
      const notes={message:this.copy.message_note,vases:this.copy.vase_note,extras:this.copy.extras_note,delivery:''};
      this.text(this.dialog.querySelector('[data-guided-dialog-title]'),titles[group]);
      this.text(this.dialog.querySelector('[data-guided-dialog-note]'),notes[group]);
      this.dialog.querySelectorAll('[data-guided-panel]').forEach(panel=>panel.hidden=panel.dataset.guidedPanel!==group);
      this.dialog.querySelector('[data-guided-error]').hidden=true;
      this.dialog.querySelector('.pf-guided-dialog-selection').hidden=!this.groups[group];
      this.dialog.querySelector('[data-guided-breakdown]').hidden=!this.groups[group];
      this.dialog.querySelector('[data-guided-shipping]').hidden=!this.groups[group];
      if(group==='message')this.base.setNativeChoice(this.app,'buttons-3','Include message',true);
      if(!this.dialog.open)this.dialog.showModal();
      this.base.schedule();this.schedule();
    }
    close() {
      if(this.group==='message'){
        const values=[...this.app.querySelectorAll('[data-gift-fields="message"] textarea,[data-gift-fields="message"] input')].some(input=>input.value.trim());
        if(!values)this.base.setNativeChoice(this.app,'buttons-3','Include message',false);
      }
      const source=this.base.giftSources(this.app);
      this.base.plushChoosing=false;
      if(source.plush.yes?.checked&&!source.plushProducts.some(input=>input.checked&&!input.disabled))this.base.setNativeChoice(this.app,'buttons-4','Plush toy animal',false);
      this.dialog.close();this.trigger?.focus();this.group=null;this.base.schedule();
    }
    error(message,field) { const error=this.dialog.querySelector('[data-guided-error]');this.text(error,message);error.hidden=false;field?.focus(); }
    save() {
      const source=this.base.giftSources(this.app);
      if(this.group==='message'){
        const message=this.app.querySelector('textarea[id="textarea-1"]');
        if(!message?.value.trim())return this.error(this.copy.empty_message,message);
        if(message.value.length>200)return this.error(this.base.copy.limit,message);
        const invalid=[...this.dialog.querySelectorAll('[data-guided-panel="message"] input,[data-guided-panel="message"] textarea')].find(field=>!field.disabled&&!field.checkValidity());
        if(invalid){invalid.reportValidity();return;}
      }
      if(this.group==='extras'&&source.plush.yes?.checked&&!source.plushProducts.some(input=>input.checked&&!input.disabled))return this.error(this.copy.plush_required,this.row('plush').querySelector('input:not(:disabled)'));
      if(this.group==='extras'&&source.photo.yes?.checked){
        const fields=this.row('photo').querySelector('[data-gift-fields="photo"]');
        const file=fields.querySelector('input[type="file"]');
        const uploaded=fields.querySelector('[data-element-id="file-1"].upload-success input[data-has-file="true"]')&&fields.querySelector('.gpo-f-card .gpo-f-link[href]');
        if(!uploaded)return this.error(this.copy.photo_required,file);
      }
      this.close();
    }
    clear() {
      if(this.group==='vases')this.base.setNativeChoice(this.app,'buttons-1','Incluir Jarrón',false);
      if(this.group==='extras')this.base.plushChoosing=false;
      if(this.group==='extras')for(const [id,name] of [['buttons-6','Greens'],['buttons-2','Include chocolates'],['buttons-4','Plush toy animal'],['buttons-5','Polaroid']])this.base.setNativeChoice(this.app,id,name,false);
      this.base.schedule();this.schedule();
    }
    sync() {
      if(this.dead)return;
      if(!this.mounted&&!this.mount())return;
      const intro=this.scope.querySelector('.pf-product-intro');
      if(intro&&!this.price.isConnected)intro.append(this.price);
      const id=this.form.querySelector('[name="id"]')?.value;
      const variant=this.base.variants.find(v=>String(v.id)===id);
      if(variant){
        this.text(this.price,this.base.money.format(variant.price/100));
        this.sizes.querySelectorAll('[data-guided-variant]').forEach(button=>{button.setAttribute('aria-pressed',String(button.dataset.guidedVariant===id));const option=this.base.variants.find(v=>String(v.id)===button.dataset.guidedVariant);if(option)this.text(button.querySelector('small'),this.base.money.format(option.price/100));});
        const select=this.sizes.querySelector('[data-guided-variant-select]');if(select&&select.value!==id)select.value=id;
        const all=this.sizes.querySelector('[data-guided-all]');
        if(all){
          const inAll=Boolean(all.querySelector(`[data-guided-variant="${id}"]`));
          if(inAll&&this.lastSizeId!==id&&!all.open)all.open=true;
          this.text(all.querySelector('[data-guided-all-current]'),inAll?' · '+variant.title:'');
        }
        this.lastSizeId=id;
      }
      const fee=this.base.money.format(9);
      const feeNode=this.dialog.querySelector('[data-guided-delivery-fee]');
      this.text(feeNode,feeNode.dataset.guidedDeliveryFee.replace('[price]',fee));
      const shipping=this.copy.shipping.replace('[price]',fee);
      this.text(this.builder.querySelector('.pf-gift-builder__total > small'),shipping);
      for(const [group,keys] of Object.entries(this.groups)){
        const selected=keys.map(key=>this.row(key)).filter(row=>row?.dataset.selected==='true');
        const available=keys.map(key=>this.row(key)).filter(row=>row&&!row.hidden);
        const defaultRow=available[0];
        this.dialog.querySelector(`[data-guided-panel="${group}"]`).dataset.guidedCount=String(available.length);
        this.controls.querySelector(`[data-guided-open="${group}"]`).hidden=!available.length;
        if(!defaultRow)continue;
        const amount=Math.min(...available.map(row=>Number(row.dataset.price)).filter(price=>price>0));
        const availableNames=available.map(row=>row.querySelector('.pf-gift-option__copy strong').textContent);
        const hint=group==='vases'?(available.length===1?availableNames[0]:this.copy.vase_hint):availableNames.slice(0,3).join(', ');
        const initial=hint+' · '+(group==='vases'?'+':this.copy.from+' ')+this.base.money.format(amount/100);
        const label=selected.length?selected.map(row=>row.querySelector('.pf-gift-option__copy strong').textContent+' · +'+this.base.money.format(Number(row.dataset.price)/100)).join(' / '):initial;
        this.text(this.controls.querySelector(`[data-guided-summary="${group}"]`),label);
        this.controls.querySelector(`[data-guided-edit="${group}"]`).hidden=!selected.length;
        const image=(selected[0]||defaultRow).querySelector('img');
        const thumb=this.controls.querySelector(`[data-guided-thumb="${group}"]`);
        if(image&&thumb.src!==image.src)thumb.src=image.src;
      }
      if(this.group){
        const selected=Object.values(this.groups).flat().map(key=>this.row(key)).filter(row=>row?.dataset.selected==='true');
        const productLabel=variant?this.scope.querySelector('.pf-product-intro h1').textContent+(this.dataset.defaultVariant==='true'?'':' · '+variant.title):'';
        const items=variant?[{label:productLabel,price:variant.price},...selected.map(row=>({label:row.querySelector('.pf-gift-option__copy strong').textContent,price:Number(row.dataset.price||0)}))]:[];
        const breakdown=this.dialog.querySelector('[data-guided-breakdown]');
        const signature=JSON.stringify(items);
        if(this.breakdownSignature!==signature){
          breakdown.replaceChildren(...items.map(item=>{const line=document.createElement('div');const label=document.createElement('span');const price=document.createElement('strong');label.textContent=item.label;price.textContent=this.base.money.format(item.price/100);line.append(label,price);return line;}));
          this.breakdownSignature=signature;
        }
        this.text(this.dialog.querySelector('[data-guided-selection]'),this.copy.gift_total+' · '+this.builder.querySelector('[data-gift-total]').textContent);
        this.text(this.dialog.querySelector('[data-guided-shipping]'),shipping);
        this.text(this.dialog.querySelector('[data-guided-clear]'),this.group==='vases'?this.copy.clear_vase:this.copy.clear_extras);
        this.text(this.dialog.querySelector('[data-guided-save]'),this.group==='message'?this.copy.save_message:this.group==='delivery'?this.copy.close:this.copy.save);
        if(this.row('photo')?.querySelector('[data-element-id="file-1"].upload-success input[data-has-file="true"]')){
          const error=this.dialog.querySelector('[data-guided-error]');
          if(error.textContent===this.copy.photo_required)error.hidden=true;
        }
      }
      if(!this.dialog.open){
        const invalid=this.dialog.querySelector('.messages:not(:empty)');
        if(invalid){const fields=invalid.closest('[data-gift-fields]');if(fields)this.open(fields.dataset.giftFields==='message'?'message':'extras');}
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pf-mobile-hero-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pf-mobile-hero-gallery')) {
    customElements.define('pf-mobile-hero-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanupGallery) return;
        const track = this.querySelector('.pf-hero-gallery__track');
        const cards = [...this.querySelectorAll('.pf-hero-gallery__photo')];
        const status = this.querySelector('[data-gallery-status]');
        if (!track || cards.length < 2 || !status) return;
        const controller = new AbortController();
        const signal = controller.signal;
        const mobile = matchMedia('(max-width: 989px)');
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        let timer = 0, frame = 0, statusTimer = 0, started = false, imagesStarted = false, cancelled = false;
        let pointerId = null, dragging = false, dragX = 0, dragScroll = 0, suppressClickUntil = 0;
        const position = card => Math.min(card.offsetLeft - cards[0].offsetLeft, track.scrollWidth - track.clientWidth);
        const syncCaptions = () => {
          const viewport = track.getBoundingClientRect();
          cards.forEach(card => {
            const bounds = card.getBoundingClientRect();
            card.dataset.active = String(bounds.width > 0 && bounds.left >= viewport.left - 1 && bounds.right <= viewport.right + 1);
          });
        };
        const announce = () => {
          const index = cards.reduce((best, card, i) => Math.abs(position(card) - track.scrollLeft) < Math.abs(position(cards[best]) - track.scrollLeft) ? i : best, 0);
          status.textContent = cards[index].dataset.caption;
        };
        const loadCard = card => {
          if (!card || !mobile.matches) return Promise.resolve();
          const template = card.querySelector('template[data-gallery-image]');
          if (template) {
            const fragment = template.content.cloneNode(true);
            fragment.querySelector('img').loading = 'eager';
            template.before(fragment);
            template.remove();
          }
          const img = card.querySelector('img');
          return img ? img.decode().catch(() => {}) : Promise.resolve();
        };
        const imageObserver = new IntersectionObserver(entries => {
          if (!mobile.matches) return;
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              loadCard(entry.target);
              imageObserver.unobserve(entry.target);
            }
          });
        }, { root: track, rootMargin: '0px 80%' });
        const stop = () => {
          cancelled = true;
          clearTimeout(timer);
          cancelAnimationFrame(frame);
          delete this.dataset.moving;
          track.style.removeProperty('scroll-snap-type');
          syncCaptions();
        };
        const advance = async () => {
          await Promise.all([loadCard(cards[1]), loadCard(cards[2])]);
          if (cancelled || reduced.matches || !mobile.matches || document.hidden) return;
          const from = track.scrollLeft;
          const to = position(cards[1]);
          const start = performance.now();
          track.style.scrollSnapType = 'none';
          this.dataset.moving = '';
          const draw = now => {
            const t = Math.min(1, (now - start) / 1000);
            const eased = t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
            track.scrollLeft = from + (to - from) * eased;
            if (t < 1) frame = requestAnimationFrame(draw);
            else {
              delete this.dataset.moving;
              track.style.removeProperty('scroll-snap-type');
              syncCaptions();
              announce();
            }
          };
          frame = requestAnimationFrame(draw);
        };
        const visibility = new IntersectionObserver(entries => {
          if (!mobile.matches) return;
          if (!imagesStarted && entries.some(entry => entry.isIntersecting)) {
            imagesStarted = true;
            loadCard(cards[0]).then(() => {
              if (!this.isConnected || !mobile.matches) return;
              cards.slice(2).forEach(card => imageObserver.observe(card));
            });
          }
          if (started || !entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .65)) return;
          started = true;
          visibility.disconnect();
          Promise.all([document.fonts.ready, loadCard(cards[0]), loadCard(cards[1])]).then(() => {
            if (!cancelled && !reduced.matches) timer = setTimeout(advance, 2200);
          });
        }, { threshold: [0, .65] });
        visibility.observe(this);
        track.addEventListener('pointerdown', event => {
          stop();
          suppressClickUntil = 0;
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          pointerId = event.pointerId;
          dragging = false;
          dragX = event.clientX;
          dragScroll = track.scrollLeft;
        }, { signal });
        track.addEventListener('pointermove', event => {
          if (event.pointerId !== pointerId) return;
          if (!dragging && Math.abs(event.clientX - dragX) > 8) {
            dragging = true;
            track.style.scrollSnapType = 'none';
            track.setPointerCapture(event.pointerId);
          }
          if (dragging) {
            event.preventDefault();
            track.scrollLeft = dragScroll + dragX - event.clientX;
          }
        }, { signal });
        const release = event => {
          if (event.pointerId !== pointerId) return;
          if (dragging) {
            suppressClickUntil = performance.now() + 500;
            track.style.removeProperty('scroll-snap-type');
          }
          dragging = false;
          pointerId = null;
        };
        ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => track.addEventListener(type, release, { signal }));
        track.addEventListener('pointerleave', event => { if (!dragging) release(event); }, { signal });
        track.addEventListener('click', event => {
          if (event.detail > 0 && performance.now() < suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { capture: true, signal });
        track.addEventListener('scroll', () => {
          syncCaptions();
          clearTimeout(statusTimer);
          statusTimer = setTimeout(announce, 180);
        }, { passive: true, signal });
        track.addEventListener('wheel', stop, { passive: true, signal });
        track.addEventListener('focusin', event => {
          stop();
          const card = event.target.closest('.pf-hero-gallery__photo');
          if (card) {
            loadCard(card);
            if (card.matches(':focus-visible')) requestAnimationFrame(() => track.scrollTo({ left: position(card), behavior: 'instant' }));
          }
        }, { signal });
        reduced.addEventListener('change', stop, { signal });
        mobile.addEventListener('change', () => {
          stop();
          if (mobile.matches) cards.slice(2).forEach(card => imageObserver.observe(card));
        }, { signal });
        document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); }, { signal });
        this.addEventListener('shopify:block:select', event => {
          stop();
          const card = event.target.closest('.pf-hero-gallery__photo');
          if (card) {
            loadCard(card);
            track.scrollTo({ left: position(card), behavior: 'instant' });
          }
        }, { signal });
        const resize = new ResizeObserver(syncCaptions);
        resize.observe(track);
        this.cleanupGallery = () => {
          stop();
          clearTimeout(statusTimer);
          controller.abort();
          visibility.disconnect();
          imageObserver.disconnect();
          resize.disconnect();
          this.cleanupGallery = null;
        };
        syncCaptions();
      }
      disconnectedCallback() { this.cleanupGallery?.(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pf-offer-overlay"] && !Shopify.designMode) return;
  try {
    (() => {
    const closed = new WeakSet();
    const obsoleteSelector = '[data-testid="klaviyo-form-TuQjYs"],[data-testid="klaviyo-form-SFQpEK"]';
    let scheduled = false;
    let lastExternalFocus = document.activeElement;
    const isObsoleteDialog = element => element?.closest?.('[role="dialog"]')?.querySelector(obsoleteSelector);
    const closeObsolete = () => {
      scheduled = false;
      const obsoleteDialogs = new Set();
      document.querySelectorAll(obsoleteSelector).forEach(form => {
        const dialog = form.closest('[role="dialog"]');
        if (dialog) obsoleteDialogs.add(dialog);
        const close = dialog?.querySelector('button[aria-label="Close dialog"]');
        if (close && !closed.has(dialog)) { closed.add(dialog); close.click(); }
        if (dialog) {
          const heldFocus = dialog.contains(document.activeElement);
          dialog.inert = true;
          dialog.setAttribute('aria-hidden', 'true');
          if (heldFocus) {
            if (lastExternalFocus?.isConnected && lastExternalFocus !== document.body && lastExternalFocus.getClientRects().length && !lastExternalFocus.closest('[inert]')) lastExternalFocus.focus({preventScroll: true});
            else document.activeElement?.blur();
          }
        }
      });
      // A hidden/reduced-motion exit may not emit animationend. Release only
      // Klaviyo's lock, and only when every remaining Klaviyo modal is obsolete.
      // Native menu/search/cart locks use different classes and remain intact.
      const hasOtherModal = [...document.querySelectorAll('[data-kl-scroll-locking-modal="true"]')].some(dialog => !obsoleteDialogs.has(dialog));
      if (obsoleteDialogs.size && !hasOtherModal && document.body.classList.contains('klaviyo-prevent-body-scrolling')) document.body.classList.remove('klaviyo-prevent-body-scrolling');
    };
    const schedule = () => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(closeObsolete); }
    };
    document.addEventListener('focusin', event => {
      if (isObsoleteDialog(event.target)) schedule();
      else lastExternalFocus = event.target;
    }, true);
    new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true});
    new MutationObserver(schedule).observe(document.body, {attributes: true, attributeFilter: ['class']});
    closeObsolete();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pf-quantity-shortcuts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pf-quantity-shortcuts')) {
    customElements.define('pf-quantity-shortcuts', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-option-id]');
          if (!button || button.disabled) return;
          const scope = this.closest('variant-selects');
          const option = [...scope.querySelectorAll('select option')].find(item => item.dataset.optionValueId === button.dataset.optionId);
          if (!option || option.disabled) return;
          const select = option.closest('select');
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
